import * as ng from 'angular';
import { ComponentRegistration } from '../core';
let template = require('./title-bar.html');

class TitleBarComponent extends ComponentRegistration {

    constructor() {
        super('titleBar', {
            controller: TitleBarController,
            templateUrl: template,
            controllerAs: 'titleBar',
            transclude: true,
            bindings: {
                startMode: "@?",
                readOnly: "@?",
                hideButtons: "<?",
                hideCancel: "<?",
                title: '<?',
                ngDisabled: "=?",
                canSave: "=?",
                onEdit: "&",
                onSave: "&",
                onCancel: "&",
                editMode: '<?',
                enablePropagationControl: "<?",
                leftButton: '<?',
                rightButton: '<?'
            }
        });
    }
}

interface ITitleBarController {
    raiseOnEdit(): void;
    raiseOnCancel(): void;
    raiseOnSave(): void;
}

class TitleBarController implements ITitleBarController {
    private static $inject: Array<string> = [];

    //private fields
    private mode: string;
    private titleString: string;
    private buttonsHidden: boolean;
    private cancelHidden: boolean;

    //bindings
    private startMode: string;
    private readOnly: Boolean;
    private ngDisabled: Boolean;
    private canSave: Boolean;
    private onEdit: Function;
    private onSave: Function;
    private onCancel: Function;
    private enablePropagationControl: boolean;
    private modes = {
        edit: 'edit',
        readOnly: 'readOnly'
    };
    private leftButton: string;
    private rightButton: string;

    constructor() {
        console.log("titleBar controller loaded.");
    }

    public $onInit(): void {
        this.mode = this.startMode || this.modes.readOnly;
        this.readOnly = this.readOnly || false;
        this.titleString = this.title || 'Your header Title';
        this.ngDisabled = this.ngDisabled || false;
        this.buttonsHidden = this.hideButtons || false;
        this.canSave = this.canSave || true;
        console.log("Phone controller activated.");
        this.enablePropagationControl = (this.enablePropagationControl === undefined)
            ? false
            : this.enablePropagationControl;
        this.leftButton = this.leftButton || 'Cancel';
        this.rightButton = this.rightButton || 'Save';
        this.cancelHidden =  this.hideCancel || false;
    }

    public set editMode(val: boolean) {
        if (this.modes) {
            this.mode = (val === true)
                ? this.modes.edit
                : this.modes.readOnly;
        }
    }

    public get hideButtons(): boolean {
        return this.buttonsHidden || false;
    }

    public set hideButtons(val: boolean) {
        this.buttonsHidden = val;
    }

    public get hideCancel(): boolean {
        return this.cancelHidden || false;
    }

    public set hideCancel(val: boolean) {
        this.cancelHidden = val;
    }

    public get title(): string {
        return this.titleString || 'Your header Title';
    }

    public set title(val: string) {
        this.titleString = val;
    }

    public raiseOnEdit(): void {
        if (this.onEdit) {
            this.onEdit();
        }

        if (!this.readOnly) {
            this.mode = this.modes.edit;
        }

    }

    public raiseOnCancel(): void {
        let stopCancel = () => {
            this.mode = this.modes.edit;
        }

        let completeCancel = () => {
            this.mode = this.modes.edit;
        }
        if (this.onCancel) {
            this.onCancel({
                args: {
                    stopCancel: stopCancel,
                    completeCancel: completeCancel
                }
            });
        }

        if (!this.enablePropagationControl)
            this.mode = this.modes.readOnly;
    }

    public raiseOnSave(): void {
        let eventArgs = {
            cancel: () => {
                this.mode = this.modes.edit;
            }
        };

        if (this.onSave) {
            this.onSave({ args: eventArgs });
        }

        this.mode = this.modes.readOnly;
    }

}

let tbarComponent = new TitleBarComponent();
export default tbarComponent;
export { tbarComponent as TitleBarComponent, ITitleBarController, TitleBarController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/user-controls/title-bar.ts